import { ChatMessageUser } from 'features/chat/types';

export const getPrivateChatSenderId = (user: ChatMessageUser) => user.externalId || user.id;
